// extracted by mini-css-extract-plugin
module.exports = {"layout":"content-card_layout__lZRJP","meta":"content-card_meta__31V9v","hero":"content-card_hero__KnLg1","titleLink":"content-card_titleLink__PwP6w"};